// extracted by mini-css-extract-plugin
export default {"auth-header":"AuthHeader_auth-header__6rm3V","auth-header__icon":"AuthHeader_auth-header__icon__ra+jP"};